import { render, staticRenderFns } from "./UserGoalsTab.vue?vue&type=template&id=bdb6cfc2&scoped=true&"
import script from "./UserGoalsTab.vue?vue&type=script&lang=js&"
export * from "./UserGoalsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb6cfc2",
  null
  
)

export default component.exports